'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import useAccountStore from '@cerifi/state/account-store'
import useNotificationStore from '@cerifi/state/notification.store'

/** Checks the cart to see if this course is already in it, if so it will route you to the cart page
 */
export const EnrollmentCartChecker = (props: { skus: string[] }) => {
  const router = useRouter()
  const [cart, isLoadingInit] = useAccountStore((state) => [
    state.cart,
    state.isLoadingInit,
  ])
  const toast = useNotificationStore((state) => state.showToast)

  useEffect(() => {
    if (isLoadingInit) {
      return
    }

    if (cart?.lineItems?.some((item) => props.skus.includes(item.sku))) {
      toast({
        title: 'This course is already in your cart',
      })
      router.replace('/cart')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingInit, props.skus, router, toast]) // intentionally leaving out cart?.lineItems because we only want this to fire on the initial cart load, not if they add to cart later

  return <></>
}
